import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/about-us/[teamMember]/AboutUsProfilePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
